import styled from 'styled-components';

import {Button} from 'components/ui-kit/Button';
import {Hint} from 'components/ui-kit/Hint';
import {breakpoint, colors} from 'theme';

export const Form = styled.form`
    display: flex;
    flex-direction: column;
    gap: 24px;
`;

export const FormFields = styled.div`
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 16px 30px;

    @media (max-width: ${breakpoint.tablet}) {
        grid-template-columns: 1fr;
    }
`;

export const Field = styled(Hint)`
    display: flex;
    flex-direction: column;
    min-width: 0;

    > span {
        padding-bottom: 6px;
        color: ${colors.textSecondary};
        font-size: 12px;
    }
`;

export const RequiredMark = styled.span`
    margin-left: 2px;
    color: ${colors.danger} !important;
`;

export const Actions = styled.div`
    display: flex;
    justify-content: flex-end;
    gap: 16px;
`;

export const CancelButton = styled(Button)`
    width: auto;
    min-width: 160px;
`;

export const SubmitButton = styled(Button)`
    width: auto;
    min-width: 160px;
`;
